module.exports = __webpack_public_path__ + "static/3.0_landingpage_image-215cb6e624ce20673f6f1baa1ad16aaf.jpg";